import { Dispatch } from 'react';
import { TeamRequestAction } from '../team-request';
import {
  ErrorCode,
  IError,
  IRevokeRoles,
  IUser,
  ResponseCSOSHeaders,
  revokeRolesAdmin,
} from '../common';
import { compose as lcompose } from 'lodash/fp';
import { assocPath } from 'rambda';
import { right, fold, map as emap } from 'fp-ts/lib/Either';

export const saveRequest =
  (dispatchSaveRequest: ({ type, payload }: TeamRequestAction) => void) =>
  (user: IUser) =>
  (a: IRevokeRoles) =>
    lcompose(
      emap<IRevokeRoles, Promise<void>>(
        handleRequest(user.icam!.headers)(dispatchSaveRequest)
      ),
      getRequest
    )({ a });

export const getRequest = ({ a }: { a: IRevokeRoles }) =>
  lcompose(
    right,
    assocPath('requestorComments', a.requestorComments),
    assocPath('revokeList', a.revokeList)
  )({});

export const handleRequest =
  (hR: ResponseCSOSHeaders) =>
  (dispatchRequest: Dispatch<TeamRequestAction>) =>
  (request: IRevokeRoles) =>
    revokeRolesAdmin(hR)(request).then(
      fold<IError, void, void>(
        () =>
          dispatchRequest({
            type: 'SaveRequestError',
            payload: { code: ErrorCode.SaveRequestError, message: '' },
          }),
        b => {
          dispatchRequest({
            type: 'SaveRequestSuccess',
            payload: void 0,
          });
        }
      )
    );
